import { Box, Typography } from "@mui/material";

const CustomHeading = ({ tittle, subtittle }) => {
  return (
    <>
      <Box mb={2}>
        <Typography fontSize={24} fontWeight={600}>
          {tittle}
        </Typography>
        <Typography fontSize={14} fontWeight={400}>
          {subtittle}
        </Typography>
      </Box>
    </>
  );
};
export default CustomHeading;
